import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { CommunicationOptionForm, CommunicationOptionFormType } from './CommunicationOptionForm'
import { createCommunicationOption } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Communication Options',
    path: '/system/communication-options'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddCommunicationOption = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createCommunicationOption({
        description: form.description,
        cost: form.cost
      })
      createToast('success', 'Communication option created')
      navigate('/system/communication-options')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Communication Option</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Option Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <CommunicationOptionForm
              type={CommunicationOptionFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
